import { render, staticRenderFns } from "./ProductEditorPurchases.vue?vue&type=template&id=2fbe6cf3&"
import script from "./ProductEditorPurchases.vue?vue&type=script&lang=js&"
export * from "./ProductEditorPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports